<template>
  <section>
    <Header></Header>
    <div class="body">
      <div class="tech screen">

        <SectionTechWelcome/>
        <SectionTechApp/>
        <SectionTechFront/>
        <SectionTechFrontChat/>
        <SectionTechFrontChatBottom/>
        <SectionTechBackend/>
        <SectionTechDataPlay/>
        <SectionTechDistribution/>
      </div>    
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import SectionTechWelcome from "../components/SectionTechWelcome.vue";
import SectionTechApp from "../components/SectionTechApp.vue"
import SectionTechFront from "../components/SectionTechFront.vue"
import SectionTechFrontChat from "../components/SectionTechFrontChat.vue"
import SectionTechFrontChatBottom from "../components/SectionTechFrontChatBottom.vue"
import SectionTechBackend from "../components/SectionTechBackend.vue"
import SectionTechDataPlay from "../components/SectionTechDataPlay.vue"
import SectionTechDistribution from "../components/SectionTechDistribution.vue"

import loginService from "../services/loginService";
import client from "../client/client";

export default {
  name: "Main",
  components: {
    Header,
    Footer,
    SectionTechWelcome,
    SectionTechApp,
    SectionTechFront,
    SectionTechBackend,
    SectionTechDataPlay,
    SectionTechDistribution,
    SectionTechFrontChat,
    SectionTechFrontChatBottom,
  },
  data: function () {
    return {
      success: false,
      loginErrorMsg: "",
      username: "",
      password: "",
    };
  },
  mounted() {},
  methods: {
    async login() {
      if (!this.username || !this.password) return;

      const result = await loginService.login(this.username, this.password);
      if (result.r) {
        this.success = true;
        this.loginErrorMsg = "";
      } else {
        this.success = false;
        this.loginErrorMsg = result.msg;
      }
      console.log(result);
    },
  },
};
</script>

<style scoped>
</style>
